import {useSelector} from "react-redux";

const nullObj = {};

export default function useSessionPresence(id, session) {
    const presence = useSelector(store=>store.presence[session]) || nullObj;
    return presence.session ? presence.session[id] : nullObj;
}